import { jsx as p } from "react/jsx-runtime";
import { createContext as P, useState as b, useCallback as z, useEffect as E } from "react";
import { defaultNS as i } from "./index25.mjs";
const k = () => {
  const u = P(null);
  return { LocaleContext: u, LocaleProvider: ({
    i18n: r,
    languageCode: l,
    loadLangBundle: s,
    onChange: t,
    children: o
  }) => {
    const [v, m] = b(
      r.language
    ), e = z(
      (c) => {
        r.hasResourceBundle(c, i) ? (r.changeLanguage(c), m(c), t == null || t(c)) : s == null || s(c, i).then((f) => {
          r.addResourceBundle(c, i, {
            ...f
          }), r.changeLanguage(c), m(c), t == null || t(c);
        }).catch((f) => {
          console.error("Error loading lang bundle", c, f);
        });
      },
      [r, s, t]
    );
    return E(() => {
      r.isInitialized && r.language !== l && e(l);
    }, [l, e, r.isInitialized, r.language]), /* @__PURE__ */ p(u.Provider, { value: { i18n: r, currentLanguageCode: v, changeLocale: e }, children: o });
  } };
};
export {
  k as createLocaleProvider
};
